import { createContext } from 'react';

const TuitionRequestContext = createContext();

export default TuitionRequestContext;
